module.exports = __webpack_public_path__ + "static/media/nail.408adbe1.png";